import { DEFAULT_LOCALE, I18N_CONFIG } from '@medable/i18n-core'
import { TOptions } from 'i18next'

export const CUSTOM_I18N_CONFIG: TOptions = {
  ...I18N_CONFIG,

  // Namespace setup
  ns: ['app'],
  defaultNS: ['app'],
  fallbackNS: ['app'],

  locales: [DEFAULT_LOCALE],
}
